import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import "./index.scss";
import Formula3DPreview from "../../../FormulaGenerator/Formula3DPreview";
import AllTop4 from "./images/allTop4.png";
import AllTop6 from "./images/allTop6.png";
import AllBottom4 from "./images/allBottom4.png";
import AllBottom6 from "./images/allBottom6.png";
import AllBoth4 from "./images/allBoth4.png";
import AllBoth6 from "./images/allBoth6.png";
import { adentyBothImplant4, adentyBothImplant6, adentyBottomImplant4, adentyBottomImplant6, adentyTopImplant4, adentyTopImplant6 } from "./implantTypes";
import SelectionTypeList from "../../SelectionTypeList";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const AdentyFullTypeImplants = ({
  stepId,
  stepInfoPostfix,
  setNextKey,
  currentChoice,
  toggleNextBtnState
}) => {
  const {
    _t
  } = useTranslation();
  const {
    dentalData,
    setStepFormula
  } = useContext(StepContext);
  const availableTypes = useMemo(() => {
    return {
      PSP_ET_e1_e2_adenty_adentyTop_adentyTopImplant: [{
        key: "adentyTopImplant4",
        img: AllTop4,
        name: _t("Все на четырех")
      }, {
        key: "adentyTopImplant6",
        img: AllTop6,
        name: _t("Все на шести")
      }],
      PSP_ET_e1_e2_adenty_adentyBottom_adentyBottomImplant: [{
        key: "adentyBottomImplant4",
        img: AllBottom4,
        name: _t("Все на четырех")
      }, {
        key: "adentyBottomImplant6",
        img: AllBottom6,
        name: _t("Все на шести")
      }],
      PSP_ET_e1_e2_adenty_adentyBoth_adentyBothImplant: [{
        key: "adentyBothImplant4",
        img: AllBoth4,
        name: _t("Все на четырех")
      }, {
        key: "adentyBothImplant6",
        img: AllBoth6,
        name: _t("Все на шести")
      }]
    };
  }, [_t]); // Reset formula for prev step

  useEffect(() => {
    if (!stepInfoPostfix && currentChoice.hasOwnProperty("formula") && currentChoice.formula.hasOwnProperty("tooth") && currentChoice.formula.tooth.some(tooth => tooth.toothElementsActive.some(el => el === "implantPosition"))) {
      toggleNextBtnState(true);
      setStepFormula(stepId, { ...dentalData,
        tooth: dentalData.tooth.map(el => ({ ...el,
          toothElementsActive: ["emptyTooth"]
        }))
      });
    }
  }, [currentChoice, dentalData, stepId, stepInfoPostfix, toggleNextBtnState]); // Disable next btn

  const runOnce = useRef(false);
  useEffect(() => {
    if (!runOnce.current) {
      if (!currentChoice || !currentChoice.hasOwnProperty("formula") || !currentChoice.formula.hasOwnProperty("tooth") || !currentChoice.formula.tooth.some(tooth => tooth.toothElementsActive.some(el => el === "implantPosition"))) {
        toggleNextBtnState(true);
        runOnce.current = true;
      }
    }
  }, [currentChoice, stepInfoPostfix, toggleNextBtnState]);
  const [isFormulaLoaded, setIsFormulaLoaded] = useState(false);

  function formulaLoadedCallback() {
    setIsFormulaLoaded(true);
  }

  const [selected, setSelected] = useState("");

  function setData(key) {
    if (!isFormulaLoaded) {
      return;
    }

    setSelected(key);
    let updatedData = {};

    switch (key) {
      case "adentyTopImplant4":
        updatedData = adentyTopImplant4;
        break;

      case "adentyTopImplant6":
        updatedData = adentyTopImplant6;
        break;

      case "adentyBottomImplant4":
        updatedData = adentyBottomImplant4;
        break;

      case "adentyBottomImplant6":
        updatedData = adentyBottomImplant6;
        break;

      case "adentyBothImplant4":
        updatedData = adentyBothImplant4;
        break;

      case "adentyBothImplant6":
        updatedData = adentyBothImplant6;
        break;

      default:
        break;
    }

    setStepFormula(stepId, updatedData);
    setNextKey(key);
    toggleNextBtnState(false);
  }

  const types = useMemo(() => {
    return availableTypes[stepId] || [];
  }, [availableTypes, stepId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "adentyFullTypeImplants"
  }, /*#__PURE__*/React.createElement("div", {
    className: "adentyFullTypeImplants-types"
  }, /*#__PURE__*/React.createElement("p", null, _t("Выберите ниже")), /*#__PURE__*/React.createElement(SelectionTypeList, {
    types: types,
    selected: selected,
    setData: setData,
    columns: 1,
    disable: !isFormulaLoaded
  })), /*#__PURE__*/React.createElement("div", {
    className: "adentyFullTypeImplants-container"
  }, /*#__PURE__*/React.createElement(Formula3DPreview, {
    stlPack: dentalData,
    onLoaded: formulaLoadedCallback,
    availableSwitchers: ["top", "bottom"]
  })));
};

export default AdentyFullTypeImplants;